import React, { useEffect, useState } from 'react';
import CustomButton from '../../../../../../../../../../../lib/designSystem/Button';
import {
  Checkbox,
  DialogActions,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Typography,
  MenuItem,
} from '@mui/material';
import {
  validatePermissions,
  showAlert,
} from '../../../../../../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../../../../../../services/redux/authSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  getMissingConfirmingApprovals,
  approveConfirmingRequest,
  rejectConfirmingRequest,
} from '../../../../../../../../../../../lib/api/confirming';
import { DECISION_NODES } from '../../../../../../../../../../../lib/consts';
import CenteredCircularProgress from '../../../../../../../../../../../lib/designSystem/CircularProgress';
import { CheckCircle } from '@mui/icons-material';
import MissingApprovalContainer from './MissingApprovalContainer';
import ComiteeUpdateDialog from './comiteeUpdate';
import DeleteComiteRevision from './DeleteRevision';

const ComiteeModule = (props: any) => {
  const { selectedRequest, setOpen, parentSetUp } = props;
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const [sure, setSure] = useState(false);
  const [requestReason, setRequestReason] = useState('');
  const [canApprove, setCanApprove] = useState(false);
  const [missingApprovals, setMissingApprovals] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [openComiteeUpdate, setOpenComiteeUpdate] = useState(false);
  const [openDeleteComitee, setOpenDeleteComitee] = useState(false);
  const [comitee, setComitee] = useState<any[]>([]);
  const [approvalsFromBusiness, setApprovalsFromBusiness] = useState<any[]>([]);
  const [approvalsFromCompany, setApprovalsFromCompany] = useState<any[]>([]);
  const [table, setTable] = useState<any>('comitee');
  const [selectedUserRoleId, setSelectedUserRoleId] = useState<number | ''>('');
  const [userRoles, setUserRoles] = useState<{ name: string }[]>([]);

  const setUpStartingInvoiceEvaluation = async () => {
    setLoading(true);
    try {
      const { rolesToApprove, comitee, businessApprovals, approvals } =
        await getMissingConfirmingApprovals(dispatch, selectedRequest.id);
      setComitee(comitee);
      const userRolesList = Array.isArray(user?.roles) ? user.roles : [];
      const requiredRoleIds = new Set(
        rolesToApprove.filter((r: any) => !r.approved).map((r: any) => r.id),
      );
      const approvedRoleIds = new Set(
        approvals
          .filter((a: any) => a.userId === user?.id)
          .map((a: any) => a.roleId),
      );
      const userRolesWithoutApproval = userRolesList.filter(
        (userRole: any) =>
          requiredRoleIds.has(userRole.id) && !approvedRoleIds.has(userRole.id),
      );
      const canApprove =
        userRolesWithoutApproval.length > 0 &&
        rolesToApprove.some((entry: any) => entry.userCanApprove);
      setCanApprove(canApprove);
      setApprovalsFromBusiness(businessApprovals);
      setApprovalsFromCompany(approvals);
      setMissingApprovals(rolesToApprove);
      console.log('missingApprovals', rolesToApprove);
      if (selectedRequest.status === 'Rechazada') {
        setCanApprove(false);
      }

      setUserRoles(userRolesWithoutApproval);
      if (userRolesWithoutApproval.length === 1) {
        setSelectedUserRoleId((userRolesWithoutApproval[0] as any).id);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const createRevisionStory = (value: number, reason: string) => {
    return [
      {
        node: 'RM: ' + reason,
        result: DECISION_NODES.APPROVED.id === value,
        nodeIdDecision: value,
      },
    ];
  };

  const handleSubmit = async (approve: boolean) => {
    if (!canSubmit) {
      return showAlert(
        dispatch,
        'error',
        'Favor de revisar los campos vacíos.',
      );
    }
    setLoading(true);
    try {
      const result = {
        confirmingRequestId: selectedRequest.id,
        reason: requestReason,
        roleId: selectedUserRoleId,
      };
      if (approve) {
        await approveConfirmingRequest(dispatch, result);
      } else {
        await rejectConfirmingRequest(dispatch, result);
      }
      showAlert(dispatch, 'success', 'Se ha revisado la solicitud con éxito.');
      setOpen(false);
      await parentSetUp(selectedRequest.id);
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al revisar la solicitud.');
    }
    setLoading(false);
  };

  const disabled = !sure || !canApprove || !comitee;
  const canSubmit = sure && requestReason.length;
  const canEdit = selectedRequest.status === 'En revisión';

  useEffect(() => {
    setUpStartingInvoiceEvaluation();
  }, []);

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      <MissingApprovalContainer
        missingApprovals={missingApprovals}
        selectedRequest={selectedRequest}
        comitee={comitee}
        approvals={approvalsFromCompany}
        table={table}
        setTable={setTable}
      />
      {approvalsFromBusiness.length > 0 && (
        <div
          style={{
            display: 'flex',
            alignContent: 'center',
            padding: '10px',
          }}
        >
          <CheckCircle style={{ marginRight: '10px', color: 'green' }} />
          <Typography variant="body1">
            El cliente aprobó la solicitud
          </Typography>
        </div>
      )}
      {canApprove && (
        <div>
          <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
            <TextField
              label="Observaciones generales"
              variant="outlined"
              margin="dense"
              multiline
              fullWidth
              value={requestReason}
              onChange={(e) => setRequestReason(e.target.value)}
            />

            {userRoles && (
              <FormControl
                margin="normal"
                style={{
                  minWidth: 200,
                  alignSelf: 'stretch',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <InputLabel id="firmas-como-label">Firmas como</InputLabel>
                <Select
                  labelId="firmas-como-label"
                  id="firmas-como-select"
                  value={selectedUserRoleId}
                  label="Firmas como"
                  onChange={(e) =>
                    setSelectedUserRoleId(e.target.value as number)
                  }
                >
                  {userRoles.map((role: any) => (
                    <MenuItem key={role.id} value={role.id}>
                      {role.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px 0px',
            }}
          >
            <Checkbox
              color="primary"
              checked={sure}
              onClick={() => setSure(!sure)}
            />
            <Typography variant="body1">
              He revisado con detención y acepto que está evaluación quedará con
              mi nombre.
            </Typography>
          </div>
        </div>
      )}
      <DialogActions>
        <CustomButton onClick={() => setOpen(false)} color="secondary">
          Salir
        </CustomButton>
        {validatePermissions(user, 'comitee_change') && canEdit && (
          <CustomButton
            onClick={() => setOpenComiteeUpdate(true)}
            color="warning"
          >
            Comité
          </CustomButton>
        )}
        {validatePermissions(user, 'comitee_delete_approval') && canEdit && (
          <CustomButton
            onClick={() => setOpenDeleteComitee(true)}
            color="error"
          >
            Borrar revisión
          </CustomButton>
        )}
        {canApprove && (
          <CustomButton
            onClick={() => handleSubmit(false)}
            color="error"
            disabled={disabled}
          >
            Rechazar
          </CustomButton>
        )}
        {canApprove && (
          <CustomButton
            onClick={() => handleSubmit(true)}
            color="success"
            disabled={disabled}
          >
            Aprobar
          </CustomButton>
        )}
      </DialogActions>
      {openComiteeUpdate && (
        <ComiteeUpdateDialog
          selectedRequest={selectedRequest}
          open={openComiteeUpdate}
          setOpen={setOpenComiteeUpdate}
          setUp={setUpStartingInvoiceEvaluation}
          comitee={comitee}
        />
      )}
      {openDeleteComitee && (
        <DeleteComiteRevision
          selectedRequest={selectedRequest}
          open={openDeleteComitee}
          setOpen={setOpenDeleteComitee}
          setUp={setUpStartingInvoiceEvaluation}
        />
      )}
    </div>
  );
};

export default ComiteeModule;
